// extracted by mini-css-extract-plugin
export default {"wrapper":"BackButton_wrapper__3CgBv","text":"BackButton_text__6xA5P","button":"BackButton_button__crRxb"};